import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { OperatorForm } from "./operator.schema";
import { Textarea } from "@/src/components/ui/textarea";
import { YachtLocation } from "../model";
import { UploadInput } from "@/src/components/ui/upload";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { extractFromMultiName } from "../../Locations/utils";
import { AddNewBoardingInfoModal } from "./AddNewBoardingInfoModal";

export type BoardingInformationProps = {
  locations: YachtLocation[];
};
export function BoardingInformation({ locations }: BoardingInformationProps) {
  const [modalOpened, setModalOpened] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ block: "start" });
      }
    }
  }, [location]);

  return (
    <div id="boarding-information" className="flex flex-col gap-4 w-full">
      <h3 className="text-lg font-semibold">Boarding Information</h3>
      {locations.map((location, i) => {
        return (
          <div key={location.id} className="bg-blue-50 border border-slate-300 rounded-md p-4">
            <h4 className="font-medium w-full mb-1">
              {extractFromMultiName(location.names)},{" "}
              {extractFromMultiName(location.town?.country.names, "Unknown country")}
            </h4>
            <p className="w-full mb-4">
              {location.longitude?.toFixed(6)},{location.latitude?.toFixed(6)}&nbsp;&nbsp;&nbsp;&nbsp;{" "}
              {location.address}
            </p>
            <div className="flex flex-row flex-wrap gap-4 items-start">
              <FormField<OperatorForm, `boardingInformations.${number}.file`>
                name={`boardingInformations.${i}.file`}
                render={({ field }) => {
                  return (
                    <FormItem>
                      <FormControl>
                        <UploadInput
                          className="bg-white px-8"
                          accept="image/svg+xml, image/png, application/pdf"
                          onChange={field.onChange}
                          value={field.value}
                          ownerType="boarding_info"
                        />
                      </FormControl>
                    </FormItem>
                  );
                }}
              />
              <FormField<OperatorForm, `boardingInformations.${number}.description`>
                name={`boardingInformations.${i}.description`}
                render={({ field }) => (
                  <FormItem className="flex-1 min-w-52">
                    <FormLabel>Boarding information</FormLabel>
                    <FormControl>
                      <Textarea className="resize-none" rows={7} {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />
            </div>
          </div>
        );
      })}
      <AddNewBoardingInfoModal
        currentLocations={locations?.map((l) => l.id)}
        opened={modalOpened}
        setOpened={(v) => setModalOpened(v)}
      />
      <FormField<OperatorForm, "notes">
        name="notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Notes</FormLabel>
            <FormControl>
              <Textarea className="resize-none" {...field} />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
}
